// Security constants: https://developer.android.com/reference/android/net/wifi/WifiInfo#SECURITY_TYPE_DPP
export const SECURITY_TYPE_DPP = 13;
export const SECURITY_TYPE_EAP = 3;
export const SECURITY_TYPE_EAP_WPA3_ENTERPRISE = 9;
export const SECURITY_TYPE_EAP_WPA3_ENTERPRISE_192_BIT = 9;
export const SECURITY_TYPE_OPEN = 0;
export const SECURITY_TYPE_OSEN = 10;
export const SECURITY_TYPE_OWE = 6;
export const SECURITY_TYPE_PASSPOINT_R1_R2 = 11;
export const SECURITY_TYPE_PASSPOINT_R3 = 12;
export const SECURITY_TYPE_PSK = 2;
export const SECURITY_TYPE_SAE = 4;
export const SECURITY_TYPE_UNKNOWN = -1;
export const SECURITY_TYPE_WAPI_CERT = 8;
export const SECURITY_TYPE_WAPI_PSK = 7;
export const SECURITY_TYPE_WEP = 1;
// ScanResult constants: https://developer.android.com/reference/android/net/wifi/ScanResult#WIFI_BAND_24_GHZ
export const WIFI_BAND_24_GHZ = 1;
export const WIFI_BAND_5_GHZ = 2;
export const WIFI_BAND_60_GHZ = 16;
export const WIFI_BAND_6_GHZ = 8;
export const WIFI_STANDARD_11AC = 5;
export const WIFI_STANDARD_11AD = 7;
export const WIFI_STANDARD_11AX = 6;
export const WIFI_STANDARD_11BE = 8;
export const WIFI_STANDARD_11N = 4;
export const WIFI_STANDARD_LEGACY = 1;
export const WIFI_STANDARD_UNKNOWN = 0;
//# sourceMappingURL=constants.js.map